import { Navigate } from "react-router-dom";
import { getDashboardPathFromToken } from "../utils/dashboardRouting";

const RedirectToDashboard = () => {
    const token = localStorage.getItem("token");

    if (!token) {
        return <Navigate to="/login" />;
    }

    try {
        return <Navigate to={getDashboardPathFromToken(token)} />;
    } catch (error) {
        localStorage.removeItem("token");
        return <Navigate to="/login" />;
    }
};

export default RedirectToDashboard;


// // src/pages/RedirectToDashboard.js
// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// const RedirectToDashboard = () => {
//     const navigate = useNavigate();

//     useEffect(() => {
//         const token = localStorage.getItem("token");

//         if (!token) {
//             navigate("/login");
//             return;
//         }

//         try {
//             const decoded = jwtDecode(token);
//             const role = decoded?.authorities?.[0];

//             switch (role) {
//                 case "ROLE_ADMIN":
//                     navigate("/dashboard");
//                     break;
//                 case "ROLE_PM":
//                     navigate("/dashboard");
//                     break;
//                 case "ROLE_PC":
//                     navigate("/pc/dashboard");
//                     break;
//                 case "ROLE_USER":
//                     navigate("/user/dashboard");
//                     break;
//                 default:
//                     navigate("/dashboard");
//             }
//         } catch (err) {
//             localStorage.removeItem("token");
//             navigate("/login");
//         }
//     }, [navigate]);

//     return null; // or a loading spinner
// };

// export default RedirectToDashboard;
